export enum Space {
  SPACE_1 = '1',
  SPACE_2 = '2',
  SPACE_3 = '3',
  SPACE_4 = '4',
  SPACE_5 = '5',
  SPACE_6 = '6',
  SPACE_7 = '7',
  SPACE_8 = '8',
  SPACE_9 = '9',
  SPACE_10 = '10',
  SPACE_12 = '12',
  SPACE_14 = '14',
  SPACE_16 = '16',
  SPACE_20 = '20',
  SPACE_24 = '24',
  SPACE_28 = '28',
  SPACE_32 = '32',
  SPACE_36 = '36',
  SPACE_40 = '40',
  SPACE_44 = '44',
  SPACE_48 = '48',
  SPACE_52 = '52',
  SPACE_56 = '56',
  SPACE_60 = '60',
  SPACE_64 = '64',
  SPACE_72 = '72',
  SPACE_80 = '80',
  PX = 'px',
  SPACE_0_5 = '0_5',
  SPACE_1_5 = '1_5',
  SPACE_2_5 = '2_5',
  SPACE_3_5 = '3_5',
  SPACE_4_5 = '4_5',
  '2XS' = '2xs',
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  '2XL' = '2xl',
}
